export default __webpack_public_path__ + "static/media/iconUpdateBy.4d1b4017.svg";